import React, { useMemo } from 'react';
import { Icon } from 'antd';
import cn from 'classnames';
import moment from 'moment';
import DateRange from '../../../../../components/DateRange/DateRange';
import DateRangePickerFooter from '../../../../../components/DateRangePickerFooter/DateRangePickerFooter';
import FilterContainer from '../../FilterContainer/FilterContainer';
import useFilterState from '../../../hooks/useFilterState';
import { searchDateFormat } from '../../../constants/common';
import RoundedButton from '../../../../../components/RoundedButton/RoundedButton';
import styles from './DateFilter.module.scss';

const DateFilter = ({
  containerKey,
  filterData,
  filterText,
  format = 'DD.MM.YYYY',
  allowRemove = true,
  disabled = false,
  className,
}) => {
  const [filter, setFilter] = useFilterState(filterData);

  const handleRangePickerChange = (dates) => {
    const dateStrings = dates.map((date) => date.format(searchDateFormat));
    setFilter(dateStrings);
  };

  const handleRangePickerFooterClick = (dates, onClose) => {
    const dateStrings = dates.range.map((item) =>
      item.format(searchDateFormat)
    );

    setFilter(dateStrings);

    onClose();
  };

  const isActiveFn = (dates) => {
    const [currentFromDate, currentToDate] = filter;
    const [fromDate, toDate] = dates.range;

    return (
      moment(currentFromDate).isSame(fromDate.format(searchDateFormat)) &&
      moment(currentToDate).isSame(toDate.format(searchDateFormat))
    );
  };

  const hasFilter = Boolean(filter[0]) && Boolean(filter[1]);

  const optionText = useMemo(() => {
    if (filter.length === 2) {
      const [fromDate, toDate] = filter;
      const start = moment(fromDate).format(format);
      const end = moment(toDate).format(format);

      return `${start} - ${end}`;
    }

    return '';
  }, [filter, format]);

  const handleRemove = () => {
    setFilter([]);
  };

  return (
    <FilterContainer className={styles.root}>
      <DateRange
        containerKey={containerKey}
        onChange={handleRangePickerChange}
        value={filter.map((item) => moment(item))}
        format={format}
        renderButton={({ onClick }) => (
          <div className={styles.buttonContainer}>
            <RoundedButton
              text={
                <div className={styles.buttonTextWrapper}>
                  <span className={styles.filterText}>{filterText}</span>
                  {hasFilter ? (
                    <span className={styles.optionText}>{optionText}</span>
                  ) : (
                    <span className={styles.optionText}>Выбрать</span>
                  )}
                </div>
              }
              className={cn(
                {
                  [styles.selected]: hasFilter,
                },
                className
              )}
              disabled={disabled}
              type="secondary"
              iconRight={<Icon type="caret-down" />}
              onClick={onClick}
            />
            {allowRemove && hasFilter && (
              <RoundedButton
                text={<Icon type="close" />} 
                className={styles.removeFiltersBtn}
                onClick={handleRemove}
              />
            )}
          </div>
        )}
        renderFooter={({ onClose }) => (
          <DateRangePickerFooter
            onRangeClick={(dates) =>
              handleRangePickerFooterClick(dates, onClose)
            }
            isActiveFn={isActiveFn}
            rootClassName={styles.rangePickerFooter}
          />
        )}
      />
    </FilterContainer>
  );
};

export default DateFilter;
